<template>
    <div id="backdefaultdiv">
        <div class="alert">
            <div class="" v-if="hasAlerts">
                <div v-for="alert in badgeData.BadgeAlertList" :key="alert.id" :value="alert.id" :class="alertClass(alert)" >

                    <label class="alerttextbold alertline1" v-html="alert.alertLine1"> </label>
                    <button class="dismissbutton alertdismissbutton" @click="dismissalert(alert)" v-if="alert.canBeDismissed">X</button>
                    <button class="tbuttondown alerttogglebutton" @click="togglealert(alert)" v-if="showdown(alert)">&#9660</button>
                    <button class="tbuttonup alerttogglebutton" @click="togglealert(alert)" v-if="showup(alert)">&#9650</button>
                    <label class="alerttext  alertline2" v-html="alert.alertLine2"></label>

                </div>
            </div>
        </div>

        <div class="info">

            <div class="infoset" v-for="contact in badgeData.badgeContactList" :key="contact.id" :value="contact.id">
                <badgecontact :contact="contact" @save="saveinfoitem"/>
            </div>    
        </div>
        <div class="school">
            <div class="infoset">
                <label class="infobig">{{badgeData.location.name}}</label>
                <label class="infobig">{{badgeData.location.phoneNumber | formatPhone}}</label>
                <label class="infosmall">{{badgeData.location.emailAddress}}</label>
                <label class="infosmall">{{badgeData.location.addressLine1}}</label>
                <label class="infosmall">{{badgeData.location.city}} {{badgeData.location.stateCode}}  {{badgeData.location.postalCode}}</label>
                <label class="infosmall">{{badgeData.location.emailAddress}}</label>
                <a class="infolink" :href="schoolwebsite" target="_blank">{{badgeData.location.website}}</a>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import smallbutton from '../controls/button.vue'
  import linkbutton from '../controls/linkbutton.vue'
  import {mapFields} from 'vuex-map-fields'
  import badge from '../../services/badge.js'
  import style from '../../style.js'
  import format from '../../format.js'
  import badgecontact from '../badgecontact.vue'
  export default {
      components:{
          badgecontact,
          smallbutton,
          linkbutton
      },
      name:"back_default",
      mixins:[style, badge,format],
      props:{
           
      },
      data(){
          return{
              
          }
      },
      computed:{
        ...mapFields([
            'badgeData',
            'imageBasePath',
            'BadgeDesign',
        ]),
      },
      methods:{
          
      }
  }
  </script>
  
  <style>

  </style>



